
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate, useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { useState, useEffect } from "react";

export function EmployeeAppNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const search = params.get("search");
    if (search) {
      setSearchQuery(search);
    }
  }, [location.search]);

  const isActivePage = (path: string) => {
    if (path === "/jobs" && (location.pathname === "/job" || location.pathname === "/jobs")) {
      return true;
    }
    return location.pathname === path;
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/jobs?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <div className="flex items-center space-x-4">
      <form onSubmit={handleSearch} className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search for Jobs"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-[300px] pl-10 bg-card border-border text-foreground placeholder:text-muted-foreground rounded"
        />
      </form>
      <Button
        variant="ghost"
        className={`transition-colors duration-200 ${
          isActivePage("/jobs")
            ? "text-foreground font-semibold"
            : "text-muted-foreground hover:text-foreground hover:bg-accent"
        }`}
        style={isActivePage("/jobs") ? { backgroundColor: `hsl(var(--nav-active))` } : undefined}
        onClick={() => navigate("/jobs")}
      >
        Jobs
      </Button>
    </div>
  );
}
